import { useEffect, useLayoutEffect, useMemo } from 'react'
import { useCookies } from '@web/walter-lib/cookies'
import { localeCookieName, validateLocale } from '@web/walter-lib/locale'
import { themeCookieName } from '@web/walter-lib/theme'
import { useLocales, useConfig, useCommonCMSConfig, useSymbols, useCurrencies } from '~api'
import { cookieOptions } from '~constants/cookies'

export const useInitializeApp = () => {
    const cookies = useCookies()

    const cookiesTheme = cookies?.get('theme')

    const locale = validateLocale(cookies?.get(localeCookieName))

    const onSetTheme = (theme: string) => {
        cookies?.set(themeCookieName, theme, cookieOptions)
    }

    // TODO: DO NOT ADD NEW FETCHERS, SHOULD BE DELETED IN FUTURE!
    const { data: locales, isLoading: isLocalesLoading } = useLocales({ data: { locale } })
    const { data: config, isLoading: isConfigLoading } = useConfig()
    const { data: cmsConfig, isLoading: isCmsConfigLoading } = useCommonCMSConfig()
    const { data: getCurrencies, isLoading: isCurrenciesLoading } = useCurrencies()
    const { isLoading: isSymbolsLoading } = useSymbols()

    // TODO: Need for FormattedCurrency, should be deleted in future, do not use in any other places
    useMemo(() => {
        window.config = {
            fallback: {
                getCurrencies,
            },
        }
    }, [getCurrencies])

    useLayoutEffect(() => {
        document.body.classList.add(cookiesTheme)
        return () => {
            document.body.classList.remove(cookiesTheme)
        }
    }, [cookiesTheme])

    useEffect(() => {
        const title = locales?.['global.broker_name']

        const titleEl = document.head.querySelector('title')

        if (titleEl && title && titleEl.textContent === 'Wallet') {
            titleEl.textContent = title
        }
    }, [locales])

    const initialTheme = cookiesTheme || cmsConfig?.themes?.night || cmsConfig?.themes?.day

    return {
        locales,
        config,
        locale,
        initialTheme,
        onSetTheme,
        isLoading: isLocalesLoading || isConfigLoading || isCmsConfigLoading || isCurrenciesLoading || isSymbolsLoading,
    }
}
